import { rem, Text, TextProps } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import menuNavbar, { IMenuItem } from 'constants/menu';
import Link from 'next/link';
import Menu, { Item as MenuItem, SubMenu } from 'rc-menu';
import 'rc-menu/assets/index.css';
import { memo } from 'react';
import styles from "./index.module.scss"



const MenuNavbar = () => {

    const mobileMatches = useMediaQuery('(max-width: 768px)')

    const textProps: TextProps = {
        c: "#333C46",
        fz: { base: rem(16), sm: rem(18) },
        lh: rem(16),
        style: { textWrap: "nowrap" },
        w: { base: "100%", sm: "auto" },
        py: rem(16),
        fw: 500,
        display: "inline",
    }


    const generateNavLinks = (menu: IMenuItem[], level: number) => {
        return menu.map((item, index) => {
            return item.children ? <SubMenu className={styles.item__menu} title={<Link className='inline w100' href={item.link}><Text {...textProps}>{item.label}</Text></Link>} key={`${level ?? 0}-` + index}>
                {generateNavLinks(item.children, level + 1)}
            </SubMenu> : <MenuItem className={styles.item__menu} key={`${level ?? 0}-` + index}>
                <Link className='inline w100' href={item.link}>
                    <Text {...textProps}>
                        {item.label}
                    </Text>
                </Link>
            </MenuItem>
        })
    }



    return (
        <Menu
            mode={mobileMatches ? 'inline' : 'horizontal'}
            direction="rtl"
            className={styles.menu + ' w100'}
        >
            {
                generateNavLinks(menuNavbar, 1)
            }
        </Menu>
    )
}

export default memo(MenuNavbar)